export default __webpack_public_path__ + "static/media/work5.d469d15e.png";